/*
 @author      Holger Schauf
 @title       Layer Elements
 @type        core module
 @description generate layer with defined content

 Example:
 var layer = new stj.layer();
 */

var stj = typeof stj !== 'undefined' ? stj : {};

stj.layer = (function ($) {
    return Class.extend({
        isOpen: false,

        cfg: {
            name: 'lyrName',
            wrapper: 'lyr',
            content: null,
            close: true,
            appendTo: 'body',
            adjustContentTo: 'body',
            contentClass: '.content',
            classes: 'lyr-abs bgt-blc-80 zdx-10 cnr',
            openCallback: null,
            closeClass: 'close-lyr',
            saveState: true,
            closeCallback: false,
            initTooltipsBySelector: false,
            scrollToView: false,
        },

        init: function (cfg) {
            this.cfg = Object.assign({}, this.cfg, cfg);
            this.cfg.stamp = new Date().getTime();
            this.cfg.id = this.cfg.name + this.cfg.stamp;

            this.generate();
        },

        generate: function () {
            if (this.cfg.close === true) {
                this.cfg.classes += ' closable';
            }

            var template = $('#' + this.cfg.wrapper);
            if (template.length === 0) {
                if (
                    typeof ApplicationProperties !== 'undefined' &&
                    !ApplicationProperties.get('external')
                ) {
                    console.log(
                        'following layer template not defined: ' +
                            this.cfg.wrapper
                    );
                }
                return false;
            }

            $.tmpl(template, this.cfg).appendTo(this.cfg.appendTo);

            this.elm = $('#' + this.cfg.id);

            if (this.cfg.close === true && this.elm && this.elm.length > 0) {
                this.elm.on('click', $.shove(this.close, this));
            }

            if (
                this.getState() === 'true' &&
                this.cfg.content !== null &&
                this.cfg.saveState
            ) {
                this.open(this.cfg.content);
            }
        },

        setContent: function (content) {
            if (this.elm && this.elm.length > 0) {
                this.elm.html(content);

                if (this.cfg.close === true) {
                    $.tmpl($('#' + this.cfg.wrapper + 'Close')).appendTo(
                        this.elm.find(this.cfg.contentClass)
                    );
                }

                this.adjustContent();
                this.setEvents();
            }
        },

        adjustContent: function () {
            if ($(this.cfg.adjustContentTo).length > 0 && this.elm.length > 0) {
                this.elm.find(this.cfg.contentClass).css({
                    marginTop:
                        $(this.cfg.adjustContentTo).offset().top +
                        $(this.cfg.adjustContentTo).outerHeight(true),
                });
            }
        },

        getElmForAdjustment: function () {
            var elm = $(this.cfg.adjustContentTo);

            return elm.length > 0 ? elm : $('body');
        },

        setEvents: function () {
            var self = this;
            var closeElements = this.elm.find('.' + this.cfg.closeClass);
            if (closeElements.length > 0) {
                closeElements.off().on('click', function () {
                    self.close(true);
                });
            }
        },

        open: function () {
            $('.tooltip').hide();
            /* check for new content */
            if (arguments.length > 0 && arguments[0] !== false) {
                this.setContent(arguments[0]);
            } else {
                this.adjustContent();
            }

            this.elm.show();
            this.isOpen = true;
            this.saveState();

            /* check for callback */
            if (arguments.length > 1) {
                arguments[1]();
            } else if (this.cfg.openCallback !== null) {
                this.cfg.openCallback();
            }

            if (this.cfg.initTooltipsBySelector !== false) {
                TipoInitByAttr(this.cfg.initTooltipsBySelector);
            }

            if (this.cfg.scrollToView !== false) {
                var elm = this.getElmForAdjustment();
                $('html, body').animate({
                    scrollTop: elm.offset().top,
                });
            }
        },

        close: function () {
            if (
                (arguments.length > 0 &&
                    typeof arguments[0] === 'boolean' &&
                    arguments[0] === true) ||
                this.cfg.id === arguments[0].target.id ||
                $(arguments[0].target).hasClass('close')
            ) {
                this.elm.hide();
                this.isOpen = false;
                this.saveState();
                if (
                    this.cfg.closeCallback !== false &&
                    typeof this.cfg.closeCallback === 'function'
                ) {
                    this.cfg.closeCallback();
                }
            }
        },

        saveState: function () {
            if (!stj.global.isSessionStorageSupported()) {
                return false;
            }
            stj.global.setSessionStorage('lyr' + this.cfg.name, this.isOpen);
        },

        getState: function () {
            if (!stj.global.isSessionStorageSupported()) {
                return false;
            }

            var status =
                stj.global.getSessionStorage('lyr' + this.cfg.name) || false;
            return status;
        },
    });
})(jQuery);
